import React from 'react';
import {imageUrl, isMobile} from 'helpers/ApplicationHelper'
import {Subtitle, Regular} from '@worthy-npm/clarity'

const ProsConsBox = (props) => {
    const mobile = isMobile()
    return (
        <div className={'pros-cons-box'}>
            <div className="header-container d-flex flex-align-center flex-col"> 
                {mobile? <Regular text={props.option.title}/>
                        :<Subtitle text={props.option.title}/>}
                <div className={'logos-container'}>
                {
                    props.option.images.map((logo, i)=> {
                        return (<div key={i} className="logo-container d-flex flex-justify-center">
                            <img className="example-logo" alt="like icon" src={imageUrl(logo)}/>
                        </div>)
                    })
                }
                </div>
            </div>
            <div className="pros-container d-flex">
                    <div className="icon-container">
                        <img className="like-icon" alt="like icon" src={imageUrl('experts/prosIcon.svg')}/>
                        <span> Pros </span>
                    </div>
                <div className="bullets-container d-flex flex-col">
                    {
                        props.option.pros.map((pro, i)=>{
                            return (
                                <div key={i} className="pro-con-bullet d-flex">
                                    <div className="pro-con-icon">
                                        <img alt="diamont-V" src={imageUrl('experts/diamondVicon.svg')}/>
                                    </div>
                                    <Regular text={pro}/>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className="cons-container d-flex">
                    <div className="icon-container">
                        <img className="like-icon" alt="dislike icon" src={imageUrl('experts/consIcon.svg')}/>
                        <span> Cons </span>
                    </div>
                <div className="bullets-container d-flex flex-col">
                    {
                        props.option.cons.map((con, i)=>{
                            return (
                                <div key={i} className="pro-con-bullet d-flex">
                                    <div className="pro-con-icon">
                                        <img alt="diamont-X" src={imageUrl('experts/diamondXicon.svg')}/>
                                    </div>
                                    <Regular text={con}/>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className="bottom-line-container d-flex">
                <div className="bottom-line-title text-center">
                    <Regular overrideCSS={{color: '#fff'}} text={"Bottom line"}/>
                </div>
                <div className="bottom-line-text">
                    {
                        <Regular bold={true} text={props.option.bottomLine}/>
                    }
                </div>
            </div>
        </div>
    );
}

export default ProsConsBox;